<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="Megtekintés"
      placement="top"
    >
      <el-button
        size="mini"
        icon="el-icon-view"
        @click="viewRepresentativeTransferRequest"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      content="Export"
      placement="top"
    >
      <el-button
        size="mini"
        :loading="exportButtonLoader"
        icon="el-icon-download"
        @click="exportRepresentativeTransferRequest"
      />
    </el-tooltip>
  </div>
</template>

<script>
  import { saveAs } from 'file-saver';

  export default {
    props: ['representativeTransferRequest'],
    data() {
      return {
        exportButtonLoader: false,
      };
    },

    methods: {
      viewRepresentativeTransferRequest() {
        this.$router.push('/representative-processes/representative-transfer-requests/view/' + this.representativeTransferRequest.id);
      },
      async exportRepresentativeTransferRequest() {
        try {
          this.exportButtonLoader = true;
          const excel = await axios({
            url: 'api/representative-transfer-requests/' + this.representativeTransferRequest.id + '/export',
            method: 'GET',
            responseType: 'blob',
          });
          saveAs(excel, 'RepresentativeTransferRequestItemExport.xlsx');
        } catch (e) {
        }
        this.exportButtonLoader = false;
      },
    }
  };
</script>
